var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (true)?_c('button',{staticClass:"back-link btn btn-link",on:{"click":_vm.onClick}},[_c('vk-icon',{attrs:{"icon":"arrow-left","ratio":1.3}})],1):_c('vk-icon-button',{staticClass:"back-link",attrs:{"icon":"arrow-left"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }